function getData(url)
{
    return fetch(url);
}

module.exports=getData;